import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {MeldingTilBruker, Varighet} from "../../../felles/tjenester/MeldingTilBruker";
import {gettextCatalog} from "angular-gettext";

export class EntitetKontroller {
    static regNavn = "entitetKontroller";

    static forInjisering = () => {
        return [
            WebNavigasjon.regNavn,
            MeldingTilBruker.regNavn,
            regNavn.ng.ui.$stateParams,
            regNavn.gettext.gettextCatalog,
            EntitetKontroller]
    };

    constructor(navigasjon: WebNavigasjon,
                meldingTilBruker: MeldingTilBruker,
                $stateParams: any,
                gettextCatalog: gettextCatalog) {

        navigasjon.gåTilEntitetRef({type: $stateParams.type, id: $stateParams.id})
            .catch(e => {
                return navigasjon.gåTilStartsiden()
                    .then(() => meldingTilBruker.infomelding(gettextCatalog.getString('Kunne ikke finne forespurt informasjon'), Varighet.timeout))
            });
    }
}
